// Mirrors _features/markets/state/slice.js's shape (selectedFilters only,
// REHYDRATE normalization) - does NOT carry forward the old
// features/billingUnitsFeature/slice.js's `billingUnits` array mirror
// (write-only dead-sync - nothing outside the feature ever read
// state.billingUnitsFeature.billingUnits; useBillingUnitsData already
// returns straight from the RTK Query cache) or its `customColumns`
// (also write-only - the filters hook reads columns from local useState,
// not the slice).
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  selectedFilters: {
    sort: "-createdAt",
  },
};

const billingUnitsFeatureSlice = createSlice({
  name: "billingUnitsFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.billingUnitsFeature) {
        const persistedData = action.payload.billingUnitsFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...persistedData.selectedFilters,
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } = billingUnitsFeatureSlice.actions;

export default billingUnitsFeatureSlice.reducer;
